import request from "../utils/request";

let token = JSON.parse(localStorage.getItem("token"));
console.log(token);
const getCodeApi = (params) => {
  return request({
    url: "/api/login_sms_app/send",
    method: "get",
    params,
  });
};

const signUpApi = (data) => {
  return request({
    url: "/api/Yyg/submit",
    method: "post",
    data,
  });
};

const getPayMsgApi = (type, label) => {
  return request({
    url: "/api/Yyg/payment",
    method: "post",
    data: {
      method: label,
      type: type,
    },
  });
};

const getOrderApi = () => {
  return request({
    url: "/api/Yyg/getOrder",
    method: "post",
  });
};

const getOpenId = (url) => {
  return request({
    url: "/api/Yyg/getOpenid",
    method: "post",
    data: {
      url,
    },
  });
};

const getUserInfoApi = () => {
  return request({
    url: "/api/Yyg/getContact",
    method: "get",
  });
};

export {
  getCodeApi,
  signUpApi,
  getPayMsgApi,
  getOrderApi,
  getOpenId,
  getUserInfoApi,
};
